import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { updateCompensationSentence, updatedCompensationSentence } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type UpdateCompensationSentenceActionPayload = ReturnType<typeof updateCompensationSentence>;

export function* updateReasonSaga({
  meta: { compensationSentence, callback },
}: UpdateCompensationSentenceActionPayload) {
  const { updateCompensationSentenceApi } = getAPI();
  const response: YieldOf<typeof updateCompensationSentenceApi> = yield call(
    updateCompensationSentenceApi,
    compensationSentence
  );
  const { ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(updatedCompensationSentence());
    if (callback) yield call(callback);
  } else {
    const error = problem || 'unknown';
    yield put(updatedCompensationSentence(undefined, error));
  }
}

export default function* ReasonSaga() {
  yield takeLatest(updateCompensationSentence.type, updateReasonSaga);
}
